import { createContext, FC, PropsWithChildren, useState } from "react";
import {
  BookingFormType,
  BookingListType,
  BookingParamsType,
  initialBooking,
  PatientBookingContextType,
} from "../../v1/types";

export const PatientBookingContext =
  createContext<PatientBookingContextType>(initialBooking);

const PatientBookingProvider: FC<PropsWithChildren> = ({ children }) => {
  const [timeSlot, setTimeSlot] = useState(initialBooking.timeSlot);
  const [bookingList, setBookingList] = useState<BookingListType[]>([]);
  const [open,setOpen] = useState<boolean>(false)
  const [refetch,setRefetch] = useState<boolean>(true)
  const [editDetails, setEditDetails] = useState<BookingFormType | null>(null);
  const [bookingSearchParam, setBookingSearchParams] = useState<BookingParamsType>(initialBooking.bookingSearchParam);
  const [copyId,setCopyId] = useState<{departmentId:number | null,doctorId:number | null}>({departmentId:null,doctorId:null})
  return (
    <PatientBookingContext.Provider
      value={{ timeSlot, setTimeSlot, bookingList, setBookingList,open,setOpen,refetch,setRefetch,editDetails, setEditDetails,bookingSearchParam,setBookingSearchParams,copyId,setCopyId }}
    >
      {children}
    </PatientBookingContext.Provider>
  );
};

export default PatientBookingProvider;
